import { useTranslation } from 'react-i18next';

import usePostCancelHelpRequest from 'Domain/host-help-partner/usePostCancelHelpRequest';
import { useModal } from 'Store/modal';

const useCancelHelpRequest = ({ helpRequest }) => {
  const { t } = useTranslation('host-help-partner');
  const { onOpenModal } = useModal();
  const { mutate: onPostCancelHelpRequest } = usePostCancelHelpRequest();

  const onOpenModalCancel = () => {
    onOpenModal({
      width: 'calc(100vw - 24px)',
      maxWidth: 'calc(100vw - 24px)',
      isOpen: true,
      type: 'cancel',
      title: t('cancel.title'),
      contentDescription: t('cancel.description'),
      showPrimaryButton: true,
      showSecondaryButton: true,
      primaryButtonText: t('common:yes_cancel'),
      secondaryButtonText: t('common:no'),
      onClickPrimaryButton: () => onPostCancelHelpRequest(helpRequest?.taskId),
    });
  };

  return onOpenModalCancel;
};

export default useCancelHelpRequest;
